// src/components/LocationBreakdown.tsx
import { AppstoreOutlined, BankOutlined, EnvironmentOutlined } from "@ant-design/icons";
import { Card, Statistic } from "antd";
import { useAuth } from "~/store";

interface LocationBreakdownProps {
  totalVolumeBK: string;
  totalVolumeLI: string;
}

export const LocationBreakdown: React.FC<LocationBreakdownProps> = ({
  totalVolumeBK,
  totalVolumeLI,
}) => {
  const { user } = useAuth();
  const isPlatformOwner = !!user?.organization?.isPlatformOwner;
  const allVolume = (parseFloat(totalVolumeBK) + parseFloat(totalVolumeLI)).toFixed(1);

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: isPlatformOwner ? "repeat(3, 1fr)" : "1fr",
        gap: 16,
        marginBottom: 16,
      }}
    >
      <Card>
        <Statistic
          title="All Volume"
          value={allVolume}
          suffix="ft³"
          prefix={<AppstoreOutlined />}
        />
      </Card>
      {isPlatformOwner && (
        <>
          <Card>
            <Statistic
              title="Volume BK"
              value={totalVolumeBK}
              suffix="ft³"
              prefix={<BankOutlined />}
            />
          </Card>
          <Card>
            <Statistic
              title="Volume LI"
              value={totalVolumeLI}
              suffix="ft³"
              prefix={<EnvironmentOutlined />}
            />
          </Card>
        </>
      )}
    </div>
  );
};
